import { useEffect } from 'react'
import Footer from '../Footer'
import Navbar from '../Navbar'
import BlogHero from './BlogHero'
import BlogList from './BlogList'

const BlogPage = () => {

  useEffect(() => {
    // Scroll to specific blog if hash exists
    const hash = window.location.hash;
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <div>
        <Navbar />
        <BlogHero />
        <BlogList />
        <Footer />
    </div>
  )
}

export default BlogPage;